import { Link } from "react-router-dom";
import { LogoFull } from "@/components/site/Logo";
import { BUSINESS } from "@/lib/content";

const COLUMNS = [
  {
    title: "Store",
    links: [
      { to: "/shop", label: "All packs", testId: "footer-shop-link" },
      { to: "/product/complete-construction-job-seeker-pack", label: "Complete Pack", testId: "footer-pack-link" },
      { to: "/shop", label: "Coming soon", testId: "footer-comingsoon-link" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/about", label: "About Sitebound", testId: "footer-about-link" },
      { to: "/faq", label: "FAQ", testId: "footer-faq-link" },
      { to: "/contact", label: "Contact us", testId: "footer-contact-link" },
      { to: "/account", label: "My account", testId: "footer-account-link" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy", testId: "footer-privacy-link" },
      { to: "/terms", label: "Terms & Conditions", testId: "footer-terms-link" },
      { to: "/refunds", label: "Refund Policy", testId: "footer-refunds-link" },
    ],
  },
];

export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A0B0D]">
      <div className="hazard-stripes h-1.5 w-full opacity-80" />
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <LogoFull />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Premium digital job seeker packs for Australian construction, civil, mining and FIFO
              work. Built for first-timers. Priced in AUD. Delivered instantly.
            </p>
            <p className="font-mono-ind mt-6 text-[10px] uppercase tracking-[0.25em] text-slate-500">
              Made in Australia
            </p>
            <p className="font-mono-ind mt-2 text-[10px] uppercase tracking-[0.25em] text-slate-500">
              {BUSINESS.name} — {BUSINESS.tagline}
            </p>
            <p className="font-mono-ind mt-2 text-[10px] uppercase tracking-[0.25em] text-slate-500">
              ABN {BUSINESS.abn}
            </p>
            <p className="mt-3 text-xs">
              <a
                data-testid="footer-email-link"
                href={`mailto:${BUSINESS.email}`}
                className="text-slate-400 transition-colors hover:text-[#FF5500]"
              >
                {BUSINESS.email}
              </a>
            </p>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="mono-label">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.testId}>
                    <Link
                      data-testid={link.testId}
                      to={link.to}
                      className="inline-block py-1 text-sm text-slate-400 transition-colors hover:text-[#FF5500]"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Sitebound. All rights reserved.
          </p>
          <p data-testid="footer-payments" className="font-mono-ind text-[10px] uppercase tracking-[0.2em] text-slate-500">
            Visa · Mastercard · Amex · Apple Pay · Google Pay
          </p>
        </div>
      </div>
    </footer>
  );
}
